<template>
    <div id="search">
      <van-nav-bar
        :placeholder="true"
        :safe-area-inset-top="true"
        :fixed="true"
        title="搜索"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
      <van-search
        style="position: fixed;top: 46px;z-index: 1000;width: 100%"
        v-model="value"
        show-action
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div @click="onClickButton" style="background: #2e86ff;color: #FFFFFF;padding: 0 10px;border-radius: 5px">搜索</div>
        </template>
      </van-search>

      <div style="position: fixed;top: 100px;z-index: 1000;width: 100%;">
        <van-row style="background: #FFFFFF;padding-bottom: 10px">
          <van-col @click="selectType(0)" :class="['select-type',{'selected': selectTypeVal === 0}]" :span="8">课后服务资讯</van-col>
          <van-col @click="selectType(1)" :class="['select-type',{'selected': selectTypeVal === 1}]" :span="8">课后服务资源</van-col>
          <van-col @click="selectType(2)" :class="['select-type',{'selected': selectTypeVal === 2}]" :span="8">课后服务培训</van-col>
        </van-row>
      </div>
      <div id="content" style="margin-top: 90px">
        <!-- 资讯 -->
        <div id="zx" :class="selectTypeVal === 0 ? '': 'list-display'">
          <empty v-if="news.newsList.length === 0"></empty>
          <van-list
            v-else
            v-model="news.loading"
            :finished="news.finished"
            finished-text="没有更多了"
            error-text="请求失败，点击重新加载"
            :immediate-check="false"
            @load="getNewsData"
          >
            <news-item v-bind:newsInfo="news.newsList"></news-item>
          </van-list>
        </div>
        <!-- 课程资源 -->
        <div id="zy" :class="selectTypeVal === 1 ? '': 'list-display'">
          <empty v-if="resource.resourceInfo.length === 0"></empty>
          <van-list
            v-else
            v-model="resource.loading"
            :finished="resource.finished"
            finished-text="没有更多了"
            error-text="请求失败，点击重新加载"
            :immediate-check="false"
            @load="getResourceData"
          >
            <resource-item v-bind:resourceInfo="resource.resourceInfo"></resource-item>
          </van-list>
        </div>

        <!-- 培训 -->
        <div id="px" :class="selectTypeVal === 2 ? '': 'list-display'">
          <empty v-if="teach.newsList.length === 0"></empty>
          <van-list
            v-else
            v-model="teach.loading"
            :finished="teach.finished"
            finished-text="没有更多了"
            error-text="请求失败，点击重新加载"
            :immediate-check="false"
            @load="getNewsData"
          >
            <news-item v-bind:newsInfo="teach.newsList"></news-item>
          </van-list>
        </div>
      </div>
      <bottom-nav></bottom-nav>
    </div>
</template>

<script>
import BottomNav from './components/BottomNav';
// import CourseItem from './components/CourseItem';
import ResourceItem from './components/ResourceItem';
import NewsItem from './components/NewsItem';
import { Empty } from '@/components';
export default {
  name: 'AfterSchoolSearch',
  components: { BottomNav, ResourceItem, NewsItem, Empty },
  data () {
    return {
      msg: '搜索',
      value: null,
      active: 0,
      resource: {
        resourceInfo: [], // 课程资源列表
        pageNo: 1,
        loading: false,
        finished: false
      },
      news: {
        newsList: [], // 资讯列表
        finished: false,
        loading: false,
        pageNo: 1
      },
      teach: {
        newsList: [], // 资讯列表
        finished: false,
        loading: false,
        pageNo: 1
      },
      selectTypeVal: 0
    };
  },
  methods: {
    onClickLeft () {
      history.back();
    },
    selectType (type) {
      this.selectTypeVal = type;
    },
    onClickButton () {
      let userInput = this.value;
      if (userInput === null || userInput === 0 || userInput === '') {
        this.$utils.toast('请输入关键字');
        return;
      }
      this.resource.resourceInfo = [];
      this.resource.pageNo = 1;
      this.news.newsList = [];
      this.news.pageNo = 1;
      this.teach.newsList = [];
      this.teach.pageNo = 1;

      this.getNewsData();// 获取活动资讯
      this.getResourceData(); // 获取资源
      this.getTeaches(); // 获取培训
    },
    getNewsData () {
      const { $http } = this;
      let newsParams = {
        pageNo: this.news.pageNo,
        consultType: 21, // 活动资讯类别，后面根据课后服务的资讯类型ID进行修改
        keyword: this.value
      };
      $http.get('search/consult', { params: newsParams }).then((res) => {
        this.news.loading = false;
        this.news.finished = !res.data.isHasNext;
        this.news.pageNo = res.data.nextPage;
        this.news.newsList.push(...res.data.result);
      });
    },
    getResourceData () {
      const { $http } = this;
      // 课程资源查询
      let resourceParams = {
        pageNo: this.resource.pageNo,
        channelId: 24
      };
      $http.get('resource/list', { params: resourceParams }).then((res) => {
        this.resource.loading = false;
        this.resource.finished = !res.data.isHasNext;
        this.resource.pageNo = res.data.nextPage;
        let resourceInfoData = res.data.result;
        resourceInfoData = resourceInfoData.filter((r) => r.title.indexOf(this.value) !== -1);
        this.resource.resourceInfo.push(...resourceInfoData);
      });
    },
    getTeaches () {
      const { $http } = this;
      let newsParams = {
        pageNo: this.teach.pageNo,
        consultType: 22, // 活动资讯类别，后面根据课后服务的资讯类型ID进行修改
        keyword: this.value
      };
      $http.get('search/consult', { params: newsParams }).then((res) => {
        this.teach.loading = false;
        this.teach.finished = !res.data.isHasNext;
        this.teach.pageNo = res.data.nextPage;
        this.teach.newsList.push(...res.data.result);
      });
    }
  }
};
</script>

<style scoped>
.tab-content{
  margin: 0 auto;
  width: 96%;
  font-size: 28px;
}
.select-type{
  font-size: 30px;
  text-align: center;
  padding: 5px 0;
}
.selected{
  color: #FFFFFF;
  background: #2e86ff;
}
.list-display{
  display: none;
}
</style>